import { render } from "./DeletedCoupons.vue?vue&type=template&id=ceee03a4&scoped=true"
import script from "./DeletedCoupons.vue?vue&type=script&lang=js"
export * from "./DeletedCoupons.vue?vue&type=script&lang=js"

import "./DeletedCoupons.vue?vue&type=style&index=0&id=ceee03a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceee03a4"]])

export default __exports__